/**
 * To make things consistent, use "create", "read", "update", and "delete" for CRUD permissions (e.g. use "update" instead of "edit")
 * When defining a permission, use the following naming convention: 'action_subject'
 * For example, a permission allowing user to retrieve business will look as follow: 'read_business'
 * Using "manage" as the action will allow all CRUD operations to be performed
 */
export const READ_ONLY_PERMISSIONS = [
    // Asset
    'read_asset',
    // Business
    'read_business',
    // Brand
    'read_brand',
    // Consignee,
    'read_consignee',
    // Consignment,
    'read_consignment',
    // Form
    'read_form',
    // Group
    'read_group',
    // Site
    'read_site',
    // User
    'read_user',
];
// Extends READ_ONLY
export const USER_PERMISSIONS = [
    // Asset
    'manage_asset',
    // Brand
    'manage_brand',
    // Consignee
    'manage_consignee',
    // Consignment,
    'manage_consignment',
    // Form
    'manage_form',
    // Group
    'manage_group',
    // Move
    'manage_move',
    // Promotion,
    'manage_promotion',
    // Site
    'manage_site',
    // Transfer
    'manage_transfer',
].concat(READ_ONLY_PERMISSIONS);
// Extends USER
export const ADMIN_PERMISSIONS = [
    // Business
    'manage_business',
    // User
    'manage_user',
].concat(USER_PERMISSIONS);
export const getPermissions = (role) => {
    switch (role) {
        case 'admin':
            return ADMIN_PERMISSIONS;
        case 'read-only':
            return READ_ONLY_PERMISSIONS;
        case 'user':
        default:
            return USER_PERMISSIONS;
    }
};
